// extracted by mini-css-extract-plugin
module.exports = {"root":"notFound_root__2KzHs","errorMessage":"notFound_errorMessage__mbVk3"};